import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#949494',
  650: '#7B7F8C',
  700: '#454F5B',
  800: '#212B36',
  850: '#1C1B1F',
  900: '#000000',
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8),
};

const PRIMARY = {
  main: '#BD2D87',
};

const SECONDARY = {
  light: '#F0EEF6',
  main: '#EFEDF7',
  dark: '#e0dcef',
  darker: '#d0cae7',
  contrastText: '#414141',
};

const INFO = {
  light: '#4dabf5',
  main: '#2196f3',
  dark: '#1769aa',
  darker: '#1769aa',
  contrastText: '#ffffff',
};

const SUCCESS = {
  // lighter: '#eafaeb',
  // light: '#d5f6d7',
  main: '#77DD77',
  // dark: '#c1f1c3',
  // darker: '#acecaf',
  // darkest: '#59d95f',
  contrastText: '#165816',
};

const WARNING = {
  // lighter: '#ffe380',
  // light: '#ffd84d',
  main: '#FF6C40',
  // dark: '#ffc800',
  // darker: '#cca000',
  contrastText: GREY[800],
};

const ERROR = {
  // light: '#fde7e7',
  main: '#DA100B',
  // dark: '#DA100B',
  // darker: '#f6716f',
  contrastText: '#fde7e7',
};

const CUSTOM = {
  main: '#EFEDF7',
  contrastText: '#536DFE',
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
  green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4'],
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  custom: { ...CUSTOM },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: GREY[500_24],
  text: { primary: GREY[900], secondary: GREY[600], disabled: GREY[500] },
  background: { paper: '#fff', default: GREY[100], neutral: GREY[200], active: GREY[300] },
  action: {
    active: GREY[600],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
